type EnumObject = Record<string, string>;

interface Option {
  value: string;
  label: string;
}

interface OptionsConfig<T extends EnumObject> {
  customLabels?: Partial<Record<keyof T, string>>;
  sortFn?: (a: Option, b: Option) => number;
  manualOrder?: (keyof T)[];
}

const getSelectDataFromEnum = <T extends EnumObject>(enumObject: T, config: OptionsConfig<T> = {}): Option[] => {
  const { customLabels = {}, sortFn, manualOrder } = config;

  const options = Object.keys(enumObject).map((key) => ({
    value: enumObject[key as keyof T],
    label: (customLabels as Record<keyof T, string>)[key as keyof T] || key,
  }));

  if (manualOrder) {
    options.sort((a, b) => manualOrder.indexOf(a.label as keyof T) - manualOrder.indexOf(b.label as keyof T));
  } else if (sortFn) {
    options.sort(sortFn);
  }

  return options;
};

const alphabeticalSort = (a: Option, b: Option) => a.label.localeCompare(b.label);

const alphabeticalSortOther = (a: Option, b: Option) => {
  if (a.label === 'Any' || a.label === 'Other') return 1;
  if (b.label === 'Any' || b.label === 'Other') return -1;
  return a.label.localeCompare(b.label);
};

export { getSelectDataFromEnum, alphabeticalSort, alphabeticalSortOther };
